import { createStore } from "vuex";

const MOCK_STREAM_TOPIC = "/topic/stream";
const MOCK_SOCKET_CONNECTING = 0;
const MOCK_SOCKET_OPEN = 1;
const MOCK_PUSH_INTERVAL_MS = 5000;
const MOCK_ONLY_URL = "frontend-mock://stream";
const DEFAULT_STATUS_KEY = "__mock_status__";

// Excel: 白杨河24组数据(更新2.0).xlsx Sheet1 第2-25行（循环推送）
const TABLE_POINT_HEADERS = [
  "Condenser Active Power",
  "Condenser Cooling Water Inlet Temperature",
  "Condenser Inlet Pessure",
  "Condenser Inlet Temperature",
  "Condenser Outlet Temperature",
  "1#Roots Inlet Pressure",
  "1#Roots Inlet Temperature",
  "1#Roots Motor Speed",
  "1#Roots Current",
  "1#Roots Power",
  "2#Roots Inlet Temperature",
  "2#Roots Outlet Temperature",
  "2#Roots Motor Speed",
  "2#Roots Current",
  "2#Roots Power",
  "3#Liquid Ring Inlet Pressure",
  "3#Liquid Ring Inlet Temperature",
  "3#Liquid Ring Motor Speed",
  "3#Liquid Ring Current",
  "3#Liquid Ring Power",
  "Separator level",
  "Sealing Water Tempteraure",
];

const TABLE_POINT_ROWS = [
  [156, 18.7, 3.52899999999999, 26.8062, 26.386, 3.42899999999999, 22.613, 1632, 4.2354, 2.3694352344, 58.3381, 95.4931, 1358.4, 3.4242, 1.9156207512, 7.47399999999999, 35, 1450, 17.5612999999999, 9.82442342679994, "正常", 22.1],
  [260, 18.9, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 21.5],
  [158, 18.6, 3.52899999999999, 26.8062, 26.386, 3.42899999999999, 22.613, 1632, 4.2354, 2.3694352344, 58.3381, 95.4931, 1358.4, 3.4242, 1.9156207512, 7.47399999999999, 35, 1450, 17.5612999999999, 9.82442342679994, "正常", 23],
  [271, 19.1, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 21.7],
  [98, 18.8, 3.159, 24.9147999999999, 24.51, 3.059, 20.717, 1492.4, 3.84579999999999, 2.15147896879999, 49.9651, 86.8070999999999, 1208.4, 3.1126, 1.7413004936, 7.13599999999999, 35, 1450, 17.3351, 9.6978790036, "正常", 21.9],
  [290, 18.8, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 22.1],
  [92, 19, 3.159, 24.9147999999999, 24.51, 3.059, 20.717, 1492.4, 3.84579999999999, 2.15147896879999, 49.9651, 86.8070999999999, 1208.4, 3.1126, 1.7413004936, 7.13599999999999, 35, 1450, 17.3351, 9.6978790036, "正常", 21.5],
  [149, 18.9, 3.52899999999999, 26.8062, 26.386, 3.42899999999999, 22.613, 1632, 4.2354, 2.3694352344, 58.3381, 95.4931, 1358.4, 3.4242, 1.9156207512, 7.47399999999999, 35, 1450, 17.5612999999999, 9.82442342679994, "正常", 22.3],
  [204, 19.2, 3.65299999999999, 27.3777999999999, 26.9139999999999, 3.549, 23.181, 1839.2, 4.83299999999999, 2.70375418799999, 59.1104999999999, 96.2039, 1542.6, 4.0134, 2.2452404424, 7.78599999999999, 35, 1450, 17.6773, 9.8893180028, "正常", 22],
  [227, 19.1, 3.85299999999999, 28.2552999999999, 27.7639999999999, 3.724, 24.056, 1994.2, 5.33299999999999, 2.98347218799999, 59.0705, 96.2039, 1723.85, 4.6209, 2.5850978124, 8.08599999999999, 35, 1450, 17.7948, 9.9550517328, "正常", 21.8],
  [152, 19, 3.52899999999999, 26.8062, 26.386, 3.42899999999999, 22.613, 1632, 4.2354, 2.3694352344, 58.3381, 95.4931, 1358.4, 3.4242, 1.9156207512, 7.47399999999999, 35, 1450, 17.5612999999999, 9.82442342679994, "正常", 23],
  [163, 19.4, 3.52899999999999, 26.8062, 26.386, 3.42899999999999, 22.613, 1632, 4.2354, 2.3694352344, 58.3381, 95.4931, 1358.4, 3.4242, 1.9156207512, 7.47399999999999, 35, 1450, 17.5612999999999, 9.82442342679994, "正常", 23],
  [115, 19.1, 3.159, 24.9147999999999, 24.51, 3.059, 20.717, 1492.4, 3.84579999999999, 2.15147896879999, 49.9651, 86.8070999999999, 1208.4, 3.1126, 1.7413004936, 7.13599999999999, 35, 1450, 17.3351, 9.6978790036, "正常", 22],
  [263, 18.5, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 22.1],
  [255, 19.2, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 22],
  [102, 18.6, 3.159, 24.9147999999999, 24.51, 3.059, 20.717, 1492.4, 3.84579999999999, 2.15147896879999, 49.9651, 86.8070999999999, 1208.4, 3.1126, 1.7413004936, 7.13599999999999, 35, 1450, 17.3351, 9.6978790036, "正常", 21.6],
  [134, 18.9, 3.389, 26.1062, 25.706, 3.28899999999999, 21.913, 1520, 3.9194, 2.1926534584, 55.6921, 92.7871, 1254.4, 3.1402, 1.7567409272, 7.27399999999999, 35, 1450, 17.4592999999999, 9.76736095479994, "正常", 21.5],
  [286, 18.5, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 21.7],
  [253, 18.6, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 22.7],
  [94, 18.4, 3.159, 24.9147999999999, 24.51, 3.059, 20.717, 1492.4, 3.84579999999999, 2.15147896879999, 49.9651, 86.8070999999999, 1208.4, 3.1126, 1.7413004936, 7.13599999999999, 35, 1450, 17.3351, 9.6978790036, "正常", 22.3],
  [192, 19.1, 3.60099999999999, 27.1337999999999, 26.6739999999999, 3.501, 22.937, 1812, 4.74659999999999, 2.65541891759999, 58.6189, 95.6839, 1509.6, 3.9138, 2.1895206168, 7.72599999999999, 35, 1450, 17.6476999999999, 9.87275869719994, "正常", 22.2],
  [273, 18.8, 4.093, 29.2952999999999, 28.8039999999999, 3.924, 25.096, 2042.2, 5.565, 3.11326134, 58.6945, 95.9918999999999, 1845.85, 5.0489, 2.8245364204, 8.286, 35, 1450, 17.8868, 10.0065198448, "正常", 22.8],
  [238, 19.2, 3.85299999999999, 28.2552999999999, 27.7639999999999, 3.724, 24.056, 1994.2, 5.33299999999999, 2.98347218799999, 59.0705, 96.2039, 1723.85, 4.6209, 2.5850978124, 8.08599999999999, 35, 1450, 17.7948, 9.9550517328, "正常", 21.6],
  [236, 19, 3.85299999999999, 28.2552999999999, 27.7639999999999, 3.724, 24.056, 1994.2, 5.33299999999999, 2.98347218799999, 59.0705, 96.2039, 1723.85, 4.6209, 2.5850978124, 8.08599999999999, 35, 1450, 17.7948, 9.9550517328, "正常", 22.5],
];

const TABLE_INDEX_BY_NAME = TABLE_POINT_HEADERS.reduce((acc, item, index) => {
  acc[item] = index;
  return acc;
}, {});

const CURRENT_TABLE_POINT_BY_EQUIP_ID = {
  // VSD420 Overall: 1#/2#/3# 泵
  // 华能山东发电有限公司这组设备下，1#/2# 电流对应关系按现场要求修正
  "5f3e0b00-a2fa-11ef-a5dd-0d36d9fdc879": "2#Roots Current",
  "d69db4e0-a2fd-11ef-a5dd-0d36d9fdc879": "1#Roots Current",
  "c14998b0-a303-11ef-a5dd-0d36d9fdc879": "3#Liquid Ring Current",
};

const PAPER_SECTION_BY_EQUIP_ID = {
  // legacy 演示id
  "739d3670-141f-11f0-8da8-0d1c443f2d5f": "pickup",
  "06b8f8e0-1420-11f0-8da8-0d1c443f2d5f": "first",
  "3a0e4c90-1420-11f0-8da8-0d1c443f2d5f": "third",
  // 更新2.0 演示id
  "7fab1e60-dfde-11f0-b610-85349516fd91": "pickup",
  "b01c64f0-dfde-11f0-b610-85349516fd91": "first",
  "4ffc20f0-dfdf-11f0-b610-85349516fd91": "third",
};

const PAPER_EP600_SOURCE_IDS = new Set([
  "739d3670-141f-11f0-8da8-0d1c443f2d5f",
  "06b8f8e0-1420-11f0-8da8-0d1c443f2d5f",
  "3a0e4c90-1420-11f0-8da8-0d1c443f2d5f",
]);

// 图片内测点按范围随机推送
const PAPER_RANGE_COMMON = {
  车速: { min: 800, max: 1100, precision: 0 },
  纸种克重: { min: 120, max: 160, precision: 0 },
  毛布使用情况: { min: 15, max: 15, precision: 0 },
  电机轴承温度D1: { min: 43, max: 45, precision: 0 },
  电机轴承温度D2: { min: 43, max: 45, precision: 0 },
  透平机震动D1: { min: 0.48, max: 0.52, precision: 3 },
  透平机震动D2: { min: 0.48, max: 0.52, precision: 3 },
  透平机轴承振动D1: { min: 5.45, max: 6.25, precision: 3 },
  透平机轴承振动D2: { min: 5.45, max: 6.25, precision: 3 },
  电机定子温度D1: { min: 40, max: 43, precision: 0 },
  电机定子温度D2: { min: 40, max: 43, precision: 0 },
  透平机蜗壳温度: { min: 68, max: 78, precision: 0 },
  透平机转速: { min: 9600, max: 12000, precision: 0 },
  电流: { min: 450, max: 600, precision: 3 },
  运行功率: { min: 812, max: 1001, precision: 0 },
  透平机真空度: { min: -55, max: -50, precision: 0 },
  供油温度: { min: 41.3, max: 41.5, precision: 1 },
  供油压力: { min: 0.25, max: 0.32, precision: 2 },
};

// EP600 型号测点单独范围
const PAPER_RANGE_EP600 = {
  电机轴承温度D1: { min: 81, max: 88, precision: 0 },
  电机轴承温度D2: { min: 85, max: 92, precision: 0 },
  电机定子温度D1: { min: 65, max: 81, precision: 0 },
  电机定子温度D2: { min: 73, max: 90, precision: 0 },
  透平机转速: { min: 7000, max: 9000, precision: 0 },
  透平机真空度: { min: -68, max: -55, precision: 1 },
  
  
};

const PAPER_RANGE_BY_SECTION = {
  pickup: {
    总脱水量: { min: 1600, max: 1900, precision: 0 },
    真空脱水量: { min: 600, max: 700, precision: 0 },
  },
  first: {
    总脱水量: { min: 850, max: 1050, precision: 0 },
    真空脱水量: { min: 300, max: 400, precision: 0 },
  },
  third: {
    总脱水量: { min: 500, max: 640, precision: 0 },
    真空脱水量: { min: 150, max: 200, precision: 0 },
  },
};

// 按最新要求：以下测点使用固定范围随机，且优先于表格循环值
const MOCK_RANGE_OVERRIDES = {
  // old -> demo alias related points
  "1#Roots Inlet Pressure": { min: 3, max: 4, precision: 2 },
  "1#Roots Inlet Temperature": { min: 20, max: 25, precision: 2 },
  "2#Roots Inlet Temperature": { min: 50, max: 60, precision: 2 },
  "2#Roots Power": { min: 1.7, max: 2.8, precision: 2 },
  "3#Liquid Ring Inlet Pressure": { min: 7, max: 8, precision: 2 },
  "3#Liquid Ring Inlet Temperature": { min: 35, max: 35, precision: 0 },
  "3#Liquid Ring Motor Speed": { min: 1450, max: 1450, precision: 0 },
  "Sealing Water Tempteraure": { min: 21.5, max: 23, precision: 1 },
  "Condenser Inlet Temperature": { min: 25, max: 30, precision: 2 },
  "Condenser Outlet Temperature": { min: 24, max: 38, precision: 2 },
  "Condenser Cooling Water Inlet Temperature": { min: 18, max: 20, precision: 2 },

  "Separator level": { min: 100, max: 200, precision: 2 },
  "2#Roots Inlet Pressure": { min: 5, max: 6, precision: 2 },
  "2#Roots Outlet Temperature": { min: 85, max: 95, precision: 2 },
  "2#Roots Current": { min: 3.1, max: 5, precision: 2 },
  "2#Roots Motor Speed": { min: 1200, max: 1845, precision: 0 },
  "1#Roots Current": { min: 3.8, max: 5.5, precision: 2 },
  "1#Roots Motor Speed": { min: 1490, max: 2040, precision: 0 },
  "1#Roots Power": { min: 2, max: 3, precision: 0 },
  "Condenser Active Power": { min: 100, max: 300, precision: 2 },
  "Condenser Inlet Pessure": { min: 3, max: 4, precision: 2 },
  "3#Liquid Ring Power": { min: 9, max: 10, precision: 0 },
  "3#Liquid Ring Current": { min: 17, max: 18, precision: 2 },

  // old staging points (only defined in range sheet)
  "一级罗茨真空泵电机变频运行频率": { min: 28, max: 34, precision: 0 },
  "二级罗茨真空泵电机变频运行频率": { min: 20, max: 31, precision: 0 },
  "水环真空泵电机变频运行频率": { min: 24, max: 24, precision: 0 },
  "凝结水出口流量": { min: 300, max: 400, precision: 0 },
  "凝结水出口流量（Q）": { min: 300, max: 400, precision: 0 },
  "冷却水出口温度": { min: 19, max: 22, precision: 2 },
};

// 华能山东发电有限公司：旧测点名 -> demo测点名
const MEASUREMENT_NAME_ALIASES = {
  一级罗茨泵入口压力: "1#Roots Inlet Pressure",
  一级罗茨泵入口温度: "1#Roots Inlet Temperature",
  一级罗茨真空泵电机变频运行电流: "1#Roots Current",
  一级罗茨真空泵电机变频运行转速: "1#Roots Motor Speed",
  一级罗茨真空泵电机变频运行功率: "1#Roots Power",
  二级罗茨泵入口压力: "2#Roots Inlet Pressure",
  二级罗茨泵入口温度: "2#Roots Inlet Temperature",
  二级罗茨泵出口温度: "2#Roots Outlet Temperature",
  二级罗茨真空泵电机变频运行电流: "2#Roots Current",
  二级罗茨真空泵电机变频运行转速: "2#Roots Motor Speed",
  二级罗茨真空泵电机变频运行功率: "2#Roots Power",
  液环泵入口压力: "3#Liquid Ring Inlet Pressure",
  汽水分离器液位: "Separator level",
  液环泵入口温度: "3#Liquid Ring Inlet Temperature",
  液环泵工作液温度: "Sealing Water Tempteraure",
  水环真空泵电机变频运行电流: "3#Liquid Ring Current",
  水环真空泵电机变频运行转速: "3#Liquid Ring Motor Speed",
  水环真空泵电机变频运行功率: "3#Liquid Ring Power",
  发电机有功功率: "Condenser Active Power",
  凝汽器入口压力: "Condenser Inlet Pessure",
  凝汽器入口温度: "Condenser Inlet Temperature",
  凝结水出口温度: "Condenser Outlet Temperature",
  冷却水入口温度: "Condenser Cooling Water Inlet Temperature",
  凝结水出口流量: "凝结水出口流量（Q）",
};

// 华能山东发电有限公司：布尔测点固定推送值
const BOOL_POINT_FIXED_VALUES = {
  真空泵组入口阀全开状态: 1,
  真空泵组入口阀全关状态: 0,
  一级罗茨真空泵电机运行状态: 1,
  一级罗茨真空泵电机变频故障状态: 0,
  "一级罗茨真空泵故障-联锁": 0,
  真空泵组入口阀打开时拒动: 0,
  真空泵组入口阀关闭时拒动: 0,
  "一级罗茨泵冷却水流量开关-低-联锁": 0,
  二级罗茨真空泵电机运行状态: 1,
  二级罗茨真空泵电机变频故障状态: 0,
  罗茨泵平衡阀开关指令: 1,
  "二级罗茨泵入口温度-高报警": 0,
  "二级罗茨泵入口温度-高高联锁": 0,
  "二级罗茨泵出口温度-高报警": 0,
  "二级罗茨泵出口温度-高高联锁": 0,
  "二级罗茨真空泵故障-联锁": 0,
  "二级罗茨泵冷却水流量开关-低-联锁": 0,
  汽水分离器补水电磁阀开关指令: 1,
  水环真空泵电机运行状态: 1,
  水环真空泵电机变频故障状态: 0,
  汽水分离器低液位报警: 0,
  "汽水分离器低液位报警-联锁": 0,
  "液环泵入口温度高-报警": 0,
  "液环泵工作液温度-报警": 0,
  "液环泵故障-联锁": 0,
  冷却水高速给水泵运行状态: 1,
  冷却水双速给水泵高速运行状态: 1,
  冷却水双速给水泵低速运行状态: 0,
};

const BOOL_POINT_NAMES = new Set([
  "真空泵组入口阀全开状态/真空泵组入口阀全关状态",
  "真空泵组入口阀全开状态",
  "真空泵组入口阀全关状态",
  "一级罗茨真空泵电机变频故障状态",
  "一级罗茨真空泵故障-联锁",
  "真空泵组入口阀打开时拒动",
  "真空泵组入口阀关闭时拒动",
  "一级罗茨泵冷却水流量开关-低-联锁",
  "罗茨泵平衡阀开关指令",
  "二级罗茨真空泵电机变频故障状态",
  "二级罗茨泵入口温度-高报警",
  "二级罗茨泵入口温度-高高联锁",
  "二级罗茨泵出口温度-高报警",
  "二级罗茨泵出口温度-高高联锁",
  "二级罗茨真空泵故障-联锁",
  "二级罗茨泵冷却水流量开关-低-联锁",
  "汽水分离器补水电磁阀开关指令",
  "水环真空泵电机变频故障状态",
  "汽水分离器低液位报警",
  "汽水分离器低液位报警-联锁",
  "液环泵入口温度高-报警",
  "液环泵工作液温度-报警",
  "液环泵故障-联锁",
  "水环真空泵电机运行状态",
  "二级罗茨真空泵电机运行状态",
  "一级罗茨真空泵电机运行状态",
  "冷却水高速给水泵运行状态",
  "冷却水双速给水泵高速运行状态",
  "冷却水双速给水泵低速运行状态",
]);

const isNumber = (value) => typeof value === "number" && Number.isFinite(value);

const toNumberOrNull = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const randomInRange = (min, max, precision = 2) => {
  const safeMin = Number(min);
  const safeMax = Number(max);
  if (!Number.isFinite(safeMin) || !Number.isFinite(safeMax)) return null;
  if (safeMin === safeMax) return Number(safeMin.toFixed(precision));
  const low = Math.min(safeMin, safeMax);
  const high = Math.max(safeMin, safeMax);
  const raw = Math.random() * (high - low) + low;
  return Number(raw.toFixed(precision));
};

const readStorageJSON = (storage, key) => {
  if (!storage) return null;
  try {
    const raw = storage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

const getDeviceSection = (device) => {
  if (!device) return "";
  if (device.shadowId && PAPER_SECTION_BY_EQUIP_ID[device.shadowId]) {
    return PAPER_SECTION_BY_EQUIP_ID[device.shadowId];
  }
  const name = String(device.equipName || "").toLowerCase();
  if (name.includes("pick-up") || name.includes("pickup")) return "pickup";
  if (name.includes("1st")) return "first";
  if (name.includes("3rd")) return "third";
  return "";
};

const isPaperEP600Device = (device) => {
  if (!device) return false;
  if (device.shadowId && PAPER_EP600_SOURCE_IDS.has(device.shadowId)) return true;
  const equipName = String(device.equipName || "").toLowerCase();
  const compactEquipName = equipName.replace(/\s+/g, "");
  return compactEquipName.includes("ep600");
};

const getPaperRangeByName = (name, section, device) => {
  if (!name) return null;
  if (isPaperEP600Device(device) && PAPER_RANGE_EP600[name]) {
    return PAPER_RANGE_EP600[name];
  }
  if (PAPER_RANGE_COMMON[name]) return PAPER_RANGE_COMMON[name];
  if (section && PAPER_RANGE_BY_SECTION[section] && PAPER_RANGE_BY_SECTION[section][name]) {
    return PAPER_RANGE_BY_SECTION[section][name];
  }
  return null;
};

const getMeasurementNameCandidates = (measurement) => {
  const names = [measurement?.fullName, measurement?.full_name, measurement?.name, measurement?.key];
  const uniqueNames = [];
  names.forEach((name) => {
    const normalized = typeof name === "string" ? name.trim() : "";
    if (!normalized) return;
    if (!uniqueNames.includes(normalized)) uniqueNames.push(normalized);
  });
  return uniqueNames;
};

const expandMeasurementNameCandidates = (measurementNames = []) => {
  const uniqueNames = [];
  const pushName = (value) => {
    const normalized = typeof value === "string" ? value.trim() : "";
    if (!normalized) return;
    if (!uniqueNames.includes(normalized)) uniqueNames.push(normalized);
  };

  measurementNames.forEach((name) => {
    pushName(name);
    pushName(MEASUREMENT_NAME_ALIASES[name]);
  });

  return uniqueNames;
};

const resolveCurrentTablePointName = (device, measurementNames) => {
  const hasCurrentName = measurementNames.some((name) => {
    const lowerName = String(name).toLowerCase();
    return lowerName === "电流" || lowerName.includes("current");
  });
  if (!hasCurrentName) return "";

  if (device?.shadowId && CURRENT_TABLE_POINT_BY_EQUIP_ID[device.shadowId]) {
    return CURRENT_TABLE_POINT_BY_EQUIP_ID[device.shadowId];
  }

  const equipName = String(device?.equipName || "").toLowerCase();
  if (
    equipName.includes("1#") ||
    equipName.includes("一级") ||
    equipName.includes("1st")
  ) {
    return "1#Roots Current";
  }
  if (
    equipName.includes("2#") ||
    equipName.includes("二级") ||
    equipName.includes("2nd")
  ) {
    return "2#Roots Current";
  }
  if (
    equipName.includes("3#") ||
    equipName.includes("三级") ||
    equipName.includes("3rd") ||
    equipName.includes("liquid ring") ||
    equipName.includes("水环")
  ) {
    return "3#Liquid Ring Current";
  }

  return "";
};

const addMeasurementToRegistry = (registry, shadowId, measurement, equipName = "") => {
  if (!shadowId || !measurement) return;
  const key = measurement.key || measurement.id;
  if (!key) return;
  if (!registry[shadowId]) {
    registry[shadowId] = {
      shadowId,
      equipName: equipName || "",
      measurements: [],
      keySet: {},
    };
  }
  const device = registry[shadowId];
  if (!device.equipName && equipName) {
    device.equipName = equipName;
  }
  if (device.keySet[key]) return;
  device.keySet[key] = true;
  device.measurements.push({
    key,
    name: measurement.name || measurement.full_name || measurement.label || key,
    fullName: measurement.full_name || measurement.fullName || "",
    unit: measurement.unit || "",
    operationThresholdLow: measurement.operationThresholdLow,
    operationThresholdHigh: measurement.operationThresholdHigh,
    standardThresholdLow: measurement.standardThresholdLow,
    standardThresholdHigh: measurement.standardThresholdHigh,
  });
};

const extractMeasurementsFromNode = (registry, node, parent = {}) => {
  if (!node) return;
  if (Array.isArray(node)) {
    node.forEach((item) => extractMeasurementsFromNode(registry, item, parent));
    return;
  }
  if (typeof node !== "object") return;

  const currentId = typeof node.id === "string" ? node.id : parent.id || "";
  const currentName = typeof node.name === "string" ? node.name : parent.name || "";

  if (node.attributes && Array.isArray(node.attributes.measurements) && currentId) {
    node.attributes.measurements.forEach((measurement) => {
      addMeasurementToRegistry(registry, currentId, measurement, currentName);
    });
  }

  if (Array.isArray(node.measurements) && currentId) {
    node.measurements.forEach((measurement) => {
      addMeasurementToRegistry(registry, currentId, measurement, currentName);
    });
  }

  if (node.eqId && node.key) {
    addMeasurementToRegistry(
      registry,
      node.eqId,
      {
        key: node.key,
        name: node.name || node.full_name || node.key,
        unit: node.unit,
        operationThresholdLow: node.operationThresholdLow,
        operationThresholdHigh: node.operationThresholdHigh,
        standardThresholdLow: node.standardThresholdLow,
        standardThresholdHigh: node.standardThresholdHigh,
      },
      node.eqName || currentName
    );
  }

  if (Array.isArray(node.children) && node.children.length) {
    node.children.forEach((child) => {
      extractMeasurementsFromNode(registry, child, { id: currentId, name: currentName });
    });
  }
};

const collectMeasurementRegistry = () => {
  const registry = {};
  const localStorageKeys = ["equipmentData", "instanceDetail", "historyData", "measureInfo"];
  const sessionStorageKeys = ["equipmentData", "instanceDetail", "historyData", "measureInfo"];

  localStorageKeys.forEach((key) => {
    extractMeasurementsFromNode(registry, readStorageJSON(window.localStorage, key));
  });
  sessionStorageKeys.forEach((key) => {
    extractMeasurementsFromNode(registry, readStorageJSON(window.sessionStorage, key));
  });

  Object.keys(registry).forEach((shadowId) => {
    delete registry[shadowId].keySet;
  });

  return registry;
};

const normalizeMeasurement = (measurement) => {
  if (!measurement) return null;
  if (typeof measurement === "string") {
    return { key: measurement, name: measurement, fullName: "" };
  }
  const key = measurement.key || measurement.id;
  if (!key) return null;
  return {
    key,
    name: measurement.name || measurement.full_name || measurement.label || key,
    fullName: measurement.full_name || measurement.fullName || "",
    unit: measurement.unit || "",
    operationThresholdLow: measurement.operationThresholdLow,
    operationThresholdHigh: measurement.operationThresholdHigh,
    standardThresholdLow: measurement.standardThresholdLow,
    standardThresholdHigh: measurement.standardThresholdHigh,
  };
};

const isBlankValue = (value) =>
  value === undefined || value === null || (typeof value === "string" && value.trim() === "");

const mergeMeasurementMetadata = (existing = {}, incoming = {}) => {
  const merged = { ...existing };
  const existingName = existing.name || "";
  const incomingName = incoming.name || "";
  const existingKey = existing.key || "";
  const incomingKey = incoming.key || "";
  const existingLooksLikeKey = existingName && (existingName === existingKey || existingName === incomingKey);
  const incomingLooksLikeKey = incomingName && incomingName === incomingKey;

  if (isBlankValue(existingName) && !isBlankValue(incomingName)) {
    merged.name = incomingName;
  } else if (existingLooksLikeKey && !incomingLooksLikeKey) {
    merged.name = incomingName;
  }

  [
    "fullName",
    "unit",
    "operationThresholdLow",
    "operationThresholdHigh",
    "standardThresholdLow",
    "standardThresholdHigh",
  ].forEach((field) => {
    if (isBlankValue(merged[field]) && !isBlankValue(incoming[field])) {
      merged[field] = incoming[field];
    }
  });

  return merged;
};

const upsertMeasurement = (measurementList, measurement) => {
  if (!measurement || !measurement.key || !Array.isArray(measurementList)) return;
  const existingIndex = measurementList.findIndex(
    (current) => current && current.key === measurement.key
  );
  if (existingIndex === -1) {
    measurementList.push(measurement);
    return;
  }
  measurementList[existingIndex] = mergeMeasurementMetadata(
    measurementList[existingIndex],
    measurement
  );
};

const ensureRegistryDevice = (registry, source) => {
  const shadowId = source.shadowId || source.id || source.eqId;
  if (!shadowId) return null;
  if (!registry[shadowId]) {
    registry[shadowId] = {
      shadowId,
      equipName: source.equipName || source.name || "",
      measurements: [],
    };
  } else if (!registry[shadowId].equipName && (source.equipName || source.name)) {
    registry[shadowId].equipName = source.equipName || source.name || "";
  }
  return registry[shadowId];
};

const mergeRegisteredMockSources = (registry, registeredSources = {}) => {
  Object.values(registeredSources).forEach((source) => {
    const targetDevice = ensureRegistryDevice(registry, source);
    if (!targetDevice) return;

    const sourceMeasurements = Array.isArray(source.measurements) ? source.measurements : [];
    sourceMeasurements.forEach((measurement) => {
      const normalized = normalizeMeasurement(measurement);
      if (!normalized) return;
      upsertMeasurement(targetDevice.measurements, normalized);
    });
  });
};

const resolveValueByThreshold = (measurement) => {
  const opLow = toNumberOrNull(measurement.operationThresholdLow);
  const opHigh = toNumberOrNull(measurement.operationThresholdHigh);
  const stdLow = toNumberOrNull(measurement.standardThresholdLow);
  const stdHigh = toNumberOrNull(measurement.standardThresholdHigh);

  let low = null;
  let high = null;

  if (opLow !== null && opHigh !== null) {
    low = Math.min(opLow, opHigh);
    high = Math.max(opLow, opHigh);
  } else if (stdLow !== null && stdHigh !== null) {
    low = Math.min(stdLow, stdHigh);
    high = Math.max(stdLow, stdHigh);
  } else if (opLow !== null) {
    low = opLow;
    high = opLow * 1.2;
  } else if (opHigh !== null) {
    low = opHigh * 0.8;
    high = opHigh;
  } else if (stdLow !== null) {
    low = stdLow;
    high = stdLow * 1.2;
  } else if (stdHigh !== null) {
    low = stdHigh * 0.8;
    high = stdHigh;
  }

  if (low === null || high === null) return null;
  const precision = Math.abs(high) >= 100 || Math.abs(low) >= 100 ? 0 : 2;
  return randomInRange(low, high, precision);
};

const resolveMockStat = (measurement, value) => {
  if (!isNumber(value)) return 0;
  const opLow = toNumberOrNull(measurement.operationThresholdLow);
  const opHigh = toNumberOrNull(measurement.operationThresholdHigh);
  const stdLow = toNumberOrNull(measurement.standardThresholdLow);
  const stdHigh = toNumberOrNull(measurement.standardThresholdHigh);

  if (opLow !== null && value < opLow) return 2;
  if (opHigh !== null && value > opHigh) return 2;
  if (stdLow !== null && value < stdLow) return 1;
  if (stdHigh !== null && value > stdHigh) return 1;

  if (opLow === null && opHigh === null && stdLow === null && stdHigh === null) {
    const random = Math.random();
    if (random < 0.03) return 2;
    if (random < 0.1) return 1;
  }
  return 0;
};

const resolveMockValue = ({ state, device, measurement, rowMap }) => {
  const memoryKey = `${device.shadowId}::${measurement.key}`;
  const rawNameCandidates = getMeasurementNameCandidates(measurement);
  const nameCandidates = expandMeasurementNameCandidates(rawNameCandidates);
  const name = nameCandidates[0] || measurement.key;

  const boolFixedName = nameCandidates.find((candidate) =>
    Object.prototype.hasOwnProperty.call(BOOL_POINT_FIXED_VALUES, candidate)
  );
  if (boolFixedName) {
    const fixedValue = BOOL_POINT_FIXED_VALUES[boolFixedName];
    state.mockValueMemory[memoryKey] = fixedValue;
    return fixedValue;
  }

  const boolMatchName = nameCandidates.find((candidate) => BOOL_POINT_NAMES.has(candidate));
  if (boolMatchName) {
    const previous = state.mockValueMemory[memoryKey];
    let next = previous === 0 || previous === 1 ? previous : Math.round(Math.random());
    if (Math.random() < 0.15) next = next === 1 ? 0 : 1;
    state.mockValueMemory[memoryKey] = next;
    return next;
  }

  const overrideName = nameCandidates.find((candidate) =>
    Object.prototype.hasOwnProperty.call(MOCK_RANGE_OVERRIDES, candidate)
  );
  if (overrideName) {
    const override = MOCK_RANGE_OVERRIDES[overrideName];
    const overrideValue = randomInRange(override.min, override.max, override.precision);
    state.mockValueMemory[memoryKey] = overrideValue;
    return overrideValue;
  }

  const tablePointName = nameCandidates.find((candidate) =>
    Object.prototype.hasOwnProperty.call(TABLE_INDEX_BY_NAME, candidate)
  );
  if (tablePointName) {
    const tableValue = rowMap[tablePointName];
    if (tablePointName === "Separator level") {
      const simulatedSeparatorValue = randomInRange(35, 55, 1);
      state.mockValueMemory[memoryKey] = simulatedSeparatorValue;
      return simulatedSeparatorValue;
    }
    if (isNumber(tableValue)) {
      state.mockValueMemory[memoryKey] = tableValue;
      return tableValue;
    }
    const tableValueAsNumber = toNumberOrNull(tableValue);
    if (tableValueAsNumber !== null) {
      state.mockValueMemory[memoryKey] = tableValueAsNumber;
      return tableValueAsNumber;
    }
  }

  const currentTablePointName = resolveCurrentTablePointName(device, nameCandidates);
  if (
    currentTablePointName &&
    Object.prototype.hasOwnProperty.call(MOCK_RANGE_OVERRIDES, currentTablePointName)
  ) {
    const override = MOCK_RANGE_OVERRIDES[currentTablePointName];
    const overrideValue = randomInRange(override.min, override.max, override.precision);
    state.mockValueMemory[memoryKey] = overrideValue;
    return overrideValue;
  }
  if (currentTablePointName && Object.prototype.hasOwnProperty.call(rowMap, currentTablePointName)) {
    const currentValue = rowMap[currentTablePointName];
    if (isNumber(currentValue)) {
      state.mockValueMemory[memoryKey] = currentValue;
      return currentValue;
    }
    const currentValueAsNumber = toNumberOrNull(currentValue);
    if (currentValueAsNumber !== null) {
      state.mockValueMemory[memoryKey] = currentValueAsNumber;
      return currentValueAsNumber;
    }
  }

  const section = getDeviceSection(device);
  const paperRangeName = nameCandidates.find(
    (candidate) => !!getPaperRangeByName(candidate, section, device)
  );
  const paperRange = getPaperRangeByName(paperRangeName, section, device);
  if (paperRange) {
    const paperValue = randomInRange(paperRange.min, paperRange.max, paperRange.precision);
    state.mockValueMemory[memoryKey] = paperValue;
    return paperValue;
  }

  const thresholdValue = resolveValueByThreshold(measurement);
  if (thresholdValue !== null) {
    state.mockValueMemory[memoryKey] = thresholdValue;
    return thresholdValue;
  }

  const previousNumeric = state.mockValueMemory[memoryKey];
  if (isNumber(previousNumeric)) {
    const jitterBase = Math.abs(previousNumeric) < 1 ? 0.05 : Math.abs(previousNumeric) * 0.02;
    const jitter = (Math.random() - 0.5) * jitterBase;
    const nextValue = Number((previousNumeric + jitter).toFixed(2));
    state.mockValueMemory[memoryKey] = nextValue;
    return nextValue;
  }

  const fallbackValue = randomInRange(10, 100, 2);
  state.mockValueMemory[memoryKey] = fallbackValue;
  return fallbackValue;
};

const getCurrentTableRowMap = (state) => {
  const row = TABLE_POINT_ROWS[state.mockTableRowCursor];
  const rowMap = {};
  TABLE_POINT_HEADERS.forEach((name, index) => {
    rowMap[name] = row[index];
  });
  state.mockTableRowCursor = (state.mockTableRowCursor + 1) % TABLE_POINT_ROWS.length;
  return rowMap;
};

const buildMockPayloads = (state) => {
  const registry = collectMeasurementRegistry();
  mergeRegisteredMockSources(registry, state.registeredMockSources);
  const deviceList = Object.values(registry);
  if (!deviceList.length) return [];

  const rowMap = getCurrentTableRowMap(state);
  const payloads = [];

  deviceList.forEach((device) => {
    const measurementList =
      Array.isArray(device.measurements) && device.measurements.length
        ? device.measurements
        : [{ key: DEFAULT_STATUS_KEY, name: DEFAULT_STATUS_KEY }];

    const report = measurementList.slice(0, 200).map((measurement) => {
      const value = resolveMockValue({ state, device, measurement, rowMap });
      return {
        id: measurement.key,
        v: value,
        stat: resolveMockStat(measurement, value),
      };
    });
    payloads.push({
      shadowId: device.shadowId,
      report,
    });
  });

  return payloads;
};

const emitMockStream = (state) => {
  if (!state.stompClient || !state.stompClient.connected) return;
  const payloads = buildMockPayloads(state);
  if (!payloads.length) return;

  Object.values(state.mockSubscriptions).forEach((subscription) => {
    if (subscription.topic !== MOCK_STREAM_TOPIC) return;
    payloads.forEach((payload) => {
      try {
        subscription.callback({ body: JSON.stringify(payload) });
      } catch (error) {
        console.error("mock websocket callback error", error);
      }
    });
  });
};

const emitMockStreamToSubscription = (state, subscriptionId) => {
  if (!state.stompClient || !state.stompClient.connected) return;
  const subscription = state.mockSubscriptions[subscriptionId];
  if (!subscription || subscription.topic !== MOCK_STREAM_TOPIC) return;

  const payloads = buildMockPayloads(state);
  if (!payloads.length) return;

  payloads.forEach((payload) => {
    try {
      subscription.callback({ body: JSON.stringify(payload) });
    } catch (error) {
      console.error("mock websocket callback error", error);
    }
  });
};

const createMockStompClient = (state) => {
  return {
    connected: true,
    debug: null,
    connect(_headers, onConnect) {
      this.connected = true;
      if (typeof onConnect === "function") onConnect();
    },
    disconnect(callback) {
      this.connected = false;
      if (typeof callback === "function") callback();
    },
    subscribe(topic, callback) {
      const id = `mock-sub-${++state.subscriptionIndex}`;
      state.mockSubscriptions[id] = { id, topic, callback };
      if (topic === MOCK_STREAM_TOPIC) {
        setTimeout(() => {
          emitMockStreamToSubscription(state, id);
        }, 0);
      }
      return {
        id,
        unsubscribe: () => {
          delete state.mockSubscriptions[id];
        },
      };
    },
    unsubscribe(id) {
      delete state.mockSubscriptions[id];
    },
    send(_topic, _headers, _data) {
      // 前端模拟模式下无需处理发送
    },
  };
};

const websocketStore = createStore({
  state: {
    url: MOCK_ONLY_URL,
    checkInterval: null,
    websocket: { readyState: MOCK_SOCKET_CONNECTING },
    stompClient: null,
    listenerList: [],
    retryCount: 0,
    mockTimer: null,
    mockSubscriptions: {},
    subscriptionIndex: 0,
    mockTableRowCursor: 0,
    mockValueMemory: {},
    registeredMockSources: {},
  },
  getters: {
    stompClient(state) {
      return function () {
        return state.stompClient;
      };
    },
  },
  mutations: {
    // 远程推送硬禁用：忽略所有后端 URL，仅保留前端模拟推送
    WEBSOCKET_INIT(state) {
      state.url = MOCK_ONLY_URL;
      if (state.stompClient && state.stompClient.connected) {
        return;
      }
      this.commit("WEBSOCKET_CONNECT");
    },
    WEBSOCKET_CONNECT(state) {
      state.websocket = { readyState: MOCK_SOCKET_OPEN };
      state.stompClient = createMockStompClient(state);
      state.retryCount = 0;
      if (!state.mockTimer) {
        state.mockTimer = setInterval(() => {
          emitMockStream(state);
        }, MOCK_PUSH_INTERVAL_MS);
      }
    },
    WEBSOCKET_SEND(state, p) {
      if (state.stompClient && state.stompClient.connected) {
        state.stompClient.send(p?.topic, {}, p?.data);
      }
    },
    WEBSOCKET_UNSUBSRCIBE(state, id) {
      if (state.stompClient && typeof state.stompClient.unsubscribe === "function") {
        state.stompClient.unsubscribe(id);
      }
      if (state.listenerList && state.listenerList.length) {
        state.listenerList = state.listenerList.filter((item) => item.topic !== id);
      }
    },
    WEBSOCKET_REGISTER_MOCK_SOURCE(state, payload) {
      const sources = Array.isArray(payload) ? payload : [payload];
      sources.forEach((source) => {
        if (!source) return;
        const shadowId = source.shadowId || source.id || source.eqId;
        if (!shadowId) return;
        if (!state.registeredMockSources[shadowId]) {
          state.registeredMockSources[shadowId] = {
            shadowId,
            equipName: source.equipName || source.name || "",
            measurements: [],
          };
        }
        const target = state.registeredMockSources[shadowId];
        if (!target.equipName && (source.equipName || source.name)) {
          target.equipName = source.equipName || source.name || "";
        }

        const sourceMeasurements = Array.isArray(source.measurements) ? source.measurements : [];
        sourceMeasurements.forEach((measurement) => {
          const normalized = normalizeMeasurement(measurement);
          if (!normalized) return;
          upsertMeasurement(target.measurements, normalized);
        });
      });
    },
    WEBSOCKET_UNREGISTER_MOCK_SOURCE(state, payload) {
      if (!payload) {
        state.registeredMockSources = {};
        return;
      }
      const sourceList = Array.isArray(payload) ? payload : [payload];
      sourceList.forEach((item) => {
        const shadowId =
          typeof item === "string" ? item : item?.shadowId || item?.id || item?.eqId;
        if (!shadowId) return;
        delete state.registeredMockSources[shadowId];
      });
    },
  },
  actions: {
    WEBSOCKET_INIT({ commit }, url) {
      commit("WEBSOCKET_INIT", url);
    },
    WEBSOCKET_SEND({ commit }, p) {
      commit("WEBSOCKET_SEND", p);
    },
    WEBSOCKET_UNSUBSRCIBE({ commit }, p) {
      commit("WEBSOCKET_UNSUBSRCIBE", p);
    },
    WEBSOCKET_REGISTER_MOCK_SOURCE({ commit }, p) {
      commit("WEBSOCKET_REGISTER_MOCK_SOURCE", p);
    },
    WEBSOCKET_UNREGISTER_MOCK_SOURCE({ commit }, p) {
      commit("WEBSOCKET_UNREGISTER_MOCK_SOURCE", p);
    },
  },
});

// 前端模拟推送默认自动连接，避免页面受 token / 网络状态影响
websocketStore.commit("WEBSOCKET_CONNECT");

export default websocketStore;
